import { useEffect, useState } from 'react';

import { Typography } from 'pixel-react';

import { CHATBOT_CONSTANTS } from '@/constants/chatbotConstants';

import styles from './StatusMessage.module.scss';

const STATUS_COLORS = [
  'var(--brand-color)',
  'var(--line-chart-data)',
  'var(--modal-header-text-color)',
];

export const StatusMessage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');

  useEffect(() => {
    let charIndex = 0;
    const typeInterval = setInterval(() => {
      setDisplayText(() =>
        CHATBOT_CONSTANTS.status_messages[currentIndex].slice(0, charIndex + 1),
      );
      charIndex++;
      if (
        charIndex === CHATBOT_CONSTANTS.status_messages[currentIndex].length
      ) {
        clearInterval(typeInterval);

        setTimeout(() => {
          if (currentIndex < CHATBOT_CONSTANTS.status_messages.length - 1) {
            setCurrentIndex(prev => prev + 1);
            setDisplayText('');
          }
        }, 1000);
      }
    }, 80);

    return () => clearInterval(typeInterval);
  }, [currentIndex]);

  return (
    <Typography
      className={styles.status_message}
      fontSize={12}
      style={{ color: STATUS_COLORS[currentIndex] }}
    >
      {displayText}
    </Typography>
  );
};
